import { State } from '../state';

export const purchases: State = {
    url: 'purchase-documents',
    oldUrls: ['documents-purchase']
};

export const newPurchaseExpense: State = {
    url: 'purchase-documents/expense/new',
    oldUrls: ['purchase-document/new'],
    parent: purchases
};

export const editPurchaseExpense: State = {
    url: 'purchase-documents/expense/edit',
    oldUrls: ['purchase-document/edit'],
    parent: purchases
};


export const newPurchaseInvoice: State = {
    url: 'purchase-documents/invoice/new',
    parent: purchases
};

export const editPurchaseInvoice: State = {
    url: 'purchase-documents/invoice/edit',
    parent: purchases
};

export const newPurchaseInvoiceAdjustment: State = {
    url: 'purchase-documents/invoice-adjustment/new',
    parent: purchases
};

export const editPurchaseInvoiceAdjustment: State = {
    url: 'purchase-documents/invoice-adjustment/edit',
    parent: purchases
};

export const editPurchaseEInvoice: State = {
    url: 'purchase-documents/e-invoice/edit',
    parent: purchases
};
